import React from 'react';
import SegmentEditCell from './components/SegmentEditCell';
import AutocompleteEditCell from './components/AutocompleteEditCell';

// Segment to category mapping based on the SQL query
export const SEGMENT_CATEGORY_MAP = {
  A: 'קטנות',
  B1: 'קטנות',
  B1L: 'קטנות',
  B2: 'משפחתיות',
  C: 'משפחתיות',
  D1: 'מנהלים',
  D1L: 'מנהלים',
  D2: 'מנהלים',
  E1: 'יוקרה',
  E2: 'יוקרה',
  F1: 'פנאי שטח',
  F2: 'פנאי שטח',
  F3: 'פנאי שטח',
  F4: 'פנאי שטח',
  F5: 'פנאי שטח',
  F6: 'פנאי שטח',
  H1: 'מיניוואנים',
  H2: 'מיניוואנים',
  E2S: 'ספורט',
  E1S: 'ספורט',
  D2S: 'ספורט',
  D1S: 'ספורט',
  I1: 'טנדרים',
  I2: 'טנדרים',
  G1: 'מסחריות',
  G2: 'מסחריות'
};

// All allowed segment values
export const SEGMENT_OPTIONS = [
  'A',
  'B1',
  'B1L',
  'B2',
  'C',
  'D1',
  'D1L',
  'D2',
  'E1',
  'E2',
  'F1',
  'F2',
  'F3',
  'F4',
  'F5',
  'F6',
  'H1',
  'H2',
  'E2S',
  'E1S',
  'D2S',
  'D1S',
  'I1',
  'I2',
  'G1',
  'G2'
];

// Fields that are required for Carwiz
export const CARWIZ_FIELDS = [
  'carwiz_make'
  // 'carwiz_model'
  // 'carwiz_submodel',
  // 'carwiz_segment'
];

// Fields that can be edited
export const EDITABLE_FIELDS = [
  'carwiz_make',
  'carwiz_model',
  'carwiz_submodel',
  'carwiz_segment'
];

// DataGrid column definitions
export const COLUMNS = (rows) => [
  {
    field: 'dmv_make',
    headerName: 'DMV Make',
    width: 200,
    editable: false,
    sortable: false,
    filterable: true,
    disableColumnMenu: false
  },
  {
    field: 'dmv_model',
    headerName: 'DMV Model',
    width: 200,
    editable: false,
    sortable: false,
    filterable: true,
    disableColumnMenu: false
  },
  {
    field: 'dmv_finish_level',
    headerName: 'DMV Finish Level',
    width: 200,
    editable: false,
    sortable: false,
    filterable: true,
    disableColumnMenu: false
  },
  {
    field: 'carwiz_make',
    headerName: 'Carwiz Make',
    width: 200,
    editable: true,
    sortable: false,
    filterable: true,
    disableColumnMenu: false,
    renderEditCell: (params) => (
      <AutocompleteEditCell
        {...params}
        rows={rows}
        filterFields={['dmv_make']}
      />
    )
  },
  {
    field: 'carwiz_model',
    headerName: 'Carwiz Model',
    width: 200,
    editable: true,
    sortable: false,
    filterable: true,
    disableColumnMenu: false,
    renderEditCell: (params) => (
      <AutocompleteEditCell
        {...params}
        rows={rows}
        filterFields={['dmv_make']}
      />
    )
  },
  {
    field: 'carwiz_submodel',
    headerName: 'Carwiz Submodel',
    width: 200,
    editable: true,
    sortable: false,
    filterable: true,
    disableColumnMenu: false,
    renderEditCell: (params) => (
      <AutocompleteEditCell
        {...params}
        rows={rows}
        filterFields={['dmv_make']}
      />
    )
  },
  {
    field: 'carwiz_finish_level',
    headerName: 'Carwiz Finish Level',
    width: 200,
    editable: true,
    sortable: false,
    filterable: true,
    disableColumnMenu: false,
    renderEditCell: (params) => (
      <AutocompleteEditCell
        {...params}
        rows={rows}
        filterFields={['dmv_make']}
      />
    ),
    renderCell: (params) => {
      const finishLevel = params.value || '';
      return finishLevel || 'אין';
    }
  },
  {
    field: 'carwiz_segment',
    headerName: 'Carwiz Segment',
    width: 200,
    editable: true,
    sortable: false,
    filterable: true,
    disableColumnMenu: false,
    renderEditCell: (params) => <SegmentEditCell {...params} />,
    renderCell: (params) => {
      const segment = params.value || '';
      const category = SEGMENT_CATEGORY_MAP[segment];
      return category ? `${segment} (${category})` : segment || 'אין';
    }
  },
  
];
